import {
  Button,
  Typography,
} from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useContext } from 'react'

import { LmnContext } from 'src/components/Dialogs/Lmn/LmnDialog'
import styles from 'src/components/Lmn/Lmn.scss'

const LmnBackButton = (): JSX.Element => {
  const { lmnContextService } = useContext(LmnContext)
  const { send } = lmnContextService
  const { palette } = useTheme()

  const handleBack = (): void => {
    send('ON_BACK')
  }
  return (
    <Button
      sx={{ color: `${palette.gray1.main} !important` }}
      variant="text"
      onClick={handleBack}
    >
      <Typography
        className={styles.lmnButtonCancel}
        color="palette.gray1"
        fontWeight="regular"
        variant="body3"
      >
        Back
      </Typography>
    </Button>
  )
}

export default LmnBackButton
